module.exports = __webpack_public_path__ + "static/img/nav3.7710f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution1/nav3.png
// module id = qePV
// module chunks = 12